import { EnqueueSnackbar } from 'notistack';
import GameModel from 'types/GameModel';
import axios from 'utils/axios';

const gameUrl = import.meta.env.VITE_APP_GAME_URL;
const adminUrl = import.meta.env.VITE_APP_ADMIN_URL;
const gamenonUrl = import.meta.env.VITE_APP_GAME_NON_URL;
const gamelistUrl = import.meta.env.VITE_APP_GAME_LIST_URL;
const RACING_URL_LBTSO = import.meta.env.VITE_APP_RACING_LBTSO_API_URL;
// Standalone MP app: always use the LBTSO racing endpoint (the source branched
// on `pathname.startsWith('/mp/')` between LBTSO and the main racing endpoint).
const racinglistUrl = () => RACING_URL_LBTSO;
/*
 * Get Game Category Events.
 */
export const apiGetGamesByMenuCategory = async (
    menu: string,
    errorEnqueueSnackbar: null | EnqueueSnackbar = null
): Promise<null | Array<GameModel>> => {
    try {
        const result = await axios.get(`/games/menu/${menu}`);
        if (result.status === 200) {
            return result.data as Array<GameModel>;
        } else {
            console.error(`Not a 200 OK, but ${result.status}`);
        }
    } catch (error: any) {
        console.error(error);
        if (errorEnqueueSnackbar) {
            errorEnqueueSnackbar(`${error?.message}: ${error.response?.data?.error || 'n/a'}`, {
                variant: 'error',
                autoHideDuration: 1000
            });
        }
    }
    return null;
};

export const getGamesData = async () => {
    const response = await axios.get(gameUrl + `/games/home`);
    return { status: true, data: response };
};

export const getBannerData = async () => {
    const response = await axios.get(adminUrl + `/racecalendar`);
    return { status: true, data: response.data };
};

export const getBfData = async () => {
    const response = await axios.get(adminUrl + `/contacts/broughtforwards/list/active`);
    return { status: true, data: response.data.body };
};

export const fetchGameDetails = async (url: string) => {
    try {
        const response = await axios.post(gamenonUrl + `${url}`);
        return { status: true, data: response };
    } catch (err: any) {
        return { status: false, error: err.response.data.message };
    }
};

export const fetchGamesDetails = async (url: any) => {
    try {
        const response = await axios.get(gamelistUrl + `${url}`);
        return { status: true, data: response };
    } catch (err: any) {
        return { status: false, error: err.error };
    }
};

export const getCurrentEventsData = async () => {
    const response = await axios.get(racinglistUrl() + `/events/active`);
    return { status: true, data: response };
};

export const contactFormSubmit = async (values: any) => {
    try {
        const response = await axios.post(`${adminUrl}/contacts/createticket`, values);
        return { status: true, data: response };
    } catch (err: any) {
        return { status: false, error: err.response.data.message };
    }
};

export async function getPayoutInfo(ticketInfo: any) {
    try {
        // Standalone MP app: always the partner-scoped payout lookup, tagged mp:true.
        const response = await axios.post(`${gameUrl}/lbpayoutinfo`, { ...ticketInfo, mp: true });
        return response.data;
    } catch (error) {
        console.error('Error updating order:', error);
        throw error;
    }
}

/**
 * Terminal balance for the partner/terminal user (sale, payout, cash in/out,
 * cash in hand). Uses VITE_APP_GAME_URL as the base. The partner token is
 * attached automatically by the axios interceptor.
 */
export async function getTerminalBalance(params?: Record<string, any>) {
    const response = await axios.get(`${gameUrl}/lbtsoterminalbalance`);
    return response.data?.body ?? response.data ?? {};
}

export async function confirmPayout(ticketInfo: any) {
    try {
        // Standalone MP app: always the partner-scoped confirm endpoint.
        const response = await axios.post(`${gameUrl}/lbconfirmpayout`, ticketInfo);
        return response.data;
    } catch (error) {
        console.error('Error updating order:', error);
        throw error;
    }
}
